import * as React from 'react';
import { Canceler } from 'axios';

import { IHistoryProps, IHistoryState, IHistoryFilters } from './types';

import API from 'src/services/api';
import HistoryList from './components/HistoryList';
import { defaultFilters } from 'src/views/TargetCheck/services/defaultFilters';
import { scrollToElement } from 'src/services/scrolling';

class History extends React.Component<IHistoryProps, IHistoryState> {
  reqCanceler: Canceler | null = null;
  filters: IHistoryFilters = defaultFilters;

  state: IHistoryState = {
    items: [],
    isLoading: true,
    currentPage: 1,
    pageCount: 1,
  };

  containerRef: React.RefObject<HTMLDivElement> = React.createRef();

  async fetchLinks() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
    const { getData, cancel } = API.ADMIN.HISTORY.get(this.filters);
    this.reqCanceler = cancel;
    const data = await getData();
    this.reqCanceler = null;
    return data;
  }

  async componentDidMount() {
    const { items, pageCount } = await this.fetchLinks();
    this.setState({
      items,
      pageCount,
      isLoading: false,
    });
  }
  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
  }

  filterDate = async (dateFilters: IHistoryFilters) => {
    this.filters = {
      ...this.filters,
      ...dateFilters,
      page: 0,
    };
    this.scrollToListTop();
    this.setState({ isLoading: true });
    const { items, pageCount } = await this.fetchLinks();
    this.setState({ items, pageCount, currentPage: 1, isLoading: false });
  };

  filterWithSearch = async (searchTerm: string) => {
    this.filters.searchTerm = searchTerm;
    this.filters.page = 0;
    this.scrollToListTop();
    this.setState({ isLoading: true });
    const { items, pageCount } = await this.fetchLinks();
    this.setState({ items, pageCount, currentPage: 1, isLoading: false });
  };

  loadPage = async (page: number) => {
    if (this.state.currentPage === page) {
      return;
    }
    this.filters.page = page;
    this.scrollToListTop();
    this.setState({ currentPage: page, isLoading: true });
    const { items } = await this.fetchLinks();
    this.setState({ items, isLoading: false });
  };

  scrollToListTop = () => {
    if (this.containerRef.current) {
      scrollToElement(this.containerRef.current);
    }
  };

  render() {
    return (
      <div ref={this.containerRef}>
        <HistoryList
          currentPath={this.props.location.pathname}
          setPage={this.loadPage}
          filterItems={this.filterWithSearch}
          filterDate={this.filterDate}
          {...this.state}
        />
      </div>
    );
  }
}

export default History;



// WEBPACK FOOTER //
// ./src/views/Admin/History/History.tsx